import { REENGAGEMENT_LIMITS } from "@school-sales-ai/shared";

export type DelayUnit = "minutes" | "hours";

/** Whole hours read as hours; anything else stays in minutes so nothing rounds. */
export function splitDelay(minutes: number): { amount: number; unit: DelayUnit } {
  return minutes % 60 === 0
    ? { amount: minutes / 60, unit: "hours" }
    : { amount: minutes, unit: "minutes" };
}

/** The delay in minutes, or null when it is out of range or not a whole number. */
export function delayToMinutes(amount: string, unit: DelayUnit): number | null {
  if (!/^\d+$/.test(amount.trim())) return null;
  const minutes = Number(amount) * (unit === "hours" ? 60 : 1);
  if (minutes < REENGAGEMENT_LIMITS.minDelayMinutes) return null;
  if (minutes > REENGAGEMENT_LIMITS.maxDelayMinutes) return null;
  return minutes;
}
